import type { StoredMutation, StoredDocument } from './webStorage'
const PREFIX = 'ink-outbox-recovery-v1:'
export interface RecoveredMutation { mutation: StoredMutation; document?: StoredDocument }
const keyFor = (mutation: StoredMutation) => PREFIX + mutation.type + ':' + mutation.targetId
export function journalMutation(mutation: StoredMutation, document?: StoredDocument): void {
  const value = JSON.stringify({ mutation, document })
  localStorage.setItem(keyFor(mutation), value)
  if (localStorage.getItem(keyFor(mutation)) !== value) throw new Error('Pending sync recovery write failed')
}
export function clearJournalMutation(mutation: StoredMutation): void {
  const key = keyFor(mutation)
  const raw = localStorage.getItem(key)
  if (raw) {
    const stored = JSON.parse(raw).mutation as StoredMutation | undefined
    if (stored && (stored.id === mutation.id || Number(stored.hlc) <= Number(mutation.hlc))) localStorage.removeItem(key)
  }
}
export function readJournalMutations(): RecoveredMutation[] {
  const recovered: RecoveredMutation[] = []
  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index)
    if (!key?.startsWith(PREFIX)) continue
    try {
      const record = JSON.parse(localStorage.getItem(key)!) as RecoveredMutation
      if (!record.mutation?.id || typeof record.mutation.targetId !== 'string' || typeof record.mutation.payload !== 'string' || !Number.isFinite(Number(record.mutation.hlc)) || !['create', 'update', 'delete'].includes(record.mutation.action) || !['document', 'project', 'settings', 'snapshot'].includes(record.mutation.type)) continue
      if (record.document) {
        for (const field of ['contentEncrypted', 'contentNonce'] as const) {
          const bytes = record.document[field]
          if (bytes) record.document[field] = new Uint8Array(Object.values(bytes))
        }
      }
      recovered.push(record)
    } catch { /* Do not erase unreadable recovery records. */ }
  }
  return recovered
}
